module.exports = __webpack_public_path__ + "static/media/dijon.b3a962b6.png";